import { Component } from 'react';
import Modal from './modal';
import cx from 'classnames';
import { Api } from '../api';

const api = new Api();

interface Props {
  globalPolicies: any;
  dismissTncModal: () => void;
}

interface State {
  isChecked: boolean;
  isDissent: boolean;
  isDeclined: boolean;
}

class TncModal extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isChecked: false,
      isDissent: false,
      isDeclined: false,
    };
  }
  public handleCheckBox = () => {
    const { isChecked } = this.state;
    this.setState({
      isChecked: !isChecked,
    });
  };
  public handleSubmit = () => {
    const { isChecked } = this.state;
    const { globalPolicies, dismissTncModal } = this.props;

    if (!isChecked) {
      this.setState({ isDissent: true });
      return;
    }

    const mfPolicies = globalPolicies.filter(
      item =>
        item.policyName === 'master_tnc' ||
        item.policyName === 'master_privacy_policy'
    );
    api.postAcceptedPolicies(mfPolicies).then(res => {
      if (res) {
        dismissTncModal();
      }
    });
  };

  public handleDeclineCase = () => {
    this.setState({
      isDeclined: true,
      isDissent: true,
    });
  };
  public render() {
    const { isDissent, isDeclined } = this.state;
    return (
      <Modal
        title=" "
        maxWidth="30%"
        disableBackButton={true}
        disableClose={true}
        hideHeader={true}
      >
        <div>
          <img
            src="https://assets1.cleartax-cdn.com/clearsave/images/1638953662_group18140734.png"
            className="full-width"
          />
          <div className="p10">
            <h5 className="text--lg">
              Please accept Terms and Conditions & Privacy Policy to continue
            </h5>
            <p className="text--md mt10">
              We place the highest importance on data privacy and security,{' '}
            </p>
            <div className="mt20">
              <input
                type="checkbox"
                id="tnc"
                name="tnc"
                onChange={this.handleCheckBox}
                className="mr5"
              />
              <label
                for="tnc"
                className={`${isDissent ? 'font--red' : ''} text--md`}
              >
                I have read and agreed to following policies -{' '}
                <a
                  href="https://clear.in/meta/privacy"
                  target="_blank"
                  className="bold"
                >
                  Privacy Policy
                </a>
                ,{' '}
                <a
                  href="https://clear.in/meta/terms"
                  target="_blank"
                  className="bold"
                >
                  Terms & Conditions
                </a>{' '}
                before proceeding.
              </label>
            </div>
            <div className="text-center">
              <button
                className="btn-full btn-blue btn-blue-solid mt20 bold hover"
                onClick={this.handleSubmit}
              >
                Accept and continue
              </button>
              <button
                className={cx('text-center font--blue-solid mt10 bold', {
                  ['hide']: isDeclined,
                })}
                onClick={this.handleDeclineCase}
              >
                I decline
              </button>

              <a
                href="https://cleartax.in/"
                className={cx('align-flex-center mt10 font--blue-solid bold', {
                  ['hide']: !isDeclined,
                })}
              >
                I decline, take me to cleartax.in
              </a>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default TncModal;



// WEBPACK FOOTER //
// ./components/tncModal.tsx